import request from '@/api/util/request'
import baseURL from '@/api/util/baseUrl'

// export function validateTicket(ticket) {
//   return request({
//     url: '/fisapp/zwfw/validateTicket?ticket=' + ticket,
//     method: 'get',
//     baseURL: baseURL.ensure,
//     headers: {
//       'Content-Type': 'application/x-www-form-urlencoded',
//     }
//   })
// }

//
export function validateTicket(data) {
  return request({
    url: '/fisapp/zwfw/validateTicket',
    method: 'post',
    baseURL: baseURL.ensure,
    data: data
  })
}


export function getTokenByTicket(data) {
  return request({
    url: '/fisapp/zwfw/getTokenByTicket',
    method: 'post',
    baseURL: baseURL.ensure,
    data: data
  });
}

export function getCustomByTicket(data) {
  return request({
    url: '/fisapp/zwfw/getCustomByTicket',
    method: 'post',
    baseURL: baseURL.ensure,
    data: data
  });
}
